import {
  FETCH_TREATMENT_CATS_REQUEST,
  FETCH_TREATMENT_CATS_SUCCESS,
  FETCH_TREATMENT_CATS_FAILURE,
  SAVE_TREATMENT_CAT_REQUEST,
  SAVE_TREATMENT_CAT_SUCCESS,
  SAVE_TREATMENT_CAT_FAILURE,
  DELETE_TREATMENT_CAT_REQUEST,
  DELETE_TREATMENT_CAT_SUCCESS,
  DELETE_TREATMENT_CAT_FAILURE,
} from './types';

const INITIAL_STATE = {
  treatmentCatList: [],
  loading: false,
  error: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_TREATMENT_CATS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_TREATMENT_CATS_SUCCESS:
      return {
        ...state,
        loading: false,
        treatmentCatList: action.payload,
      };

    case FETCH_TREATMENT_CATS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        treatmentCatList: [],
      };
    case SAVE_TREATMENT_CAT_REQUEST:
      return {
        ...state,
        error: null,
      };

    case SAVE_TREATMENT_CAT_SUCCESS:
      return {
        ...state,
      };

    case SAVE_TREATMENT_CAT_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };

    case DELETE_TREATMENT_CAT_REQUEST:
      return {
        ...state,
        error: null,
      };

    case DELETE_TREATMENT_CAT_SUCCESS:
      return {
        ...state,
      };

    case DELETE_TREATMENT_CAT_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };
    default:
      // ALWAYS have a default case in a reducer
      return state;
  }
};
